/**
 * /embed/pre-checkout-gg/$slug — variante Google Ads do pré-checkout.
 *
 * Idêntica ao /embed/pre-checkout/$slug, porém:
 * - usa os links de checkout com cupons LOTEPROMOGG / LOTEPROMOASSGG
 * - marca a origem/tag do lead como `pre-checkout-gg-{slug}` para permitir
 *   análise separada das vendas vindas do tráfego Google Ads.
 *
 * Embutida nas LPs Wix duplicadas /gg de cada pós-graduação.
 */
import { createFileRoute, notFound } from "@tanstack/react-router";
import { EmbedPreCheckoutView, isSlug } from "@/components/checkout/EmbedPreCheckoutView";

type Tipo = "unica" | "assinatura";

export const Route = createFileRoute("/embed/pre-checkout-gg/$slug")({
  validateSearch: (search: Record<string, unknown>) => ({
    tipo: (search.tipo === "assinatura" ? "assinatura" : "unica") as Tipo,
  }),
  head: ({ params }) => ({
    meta: [
      { title: `Finalizar matrícula GG · ${params.slug} · Fisio em Ortopedia` },
      { name: "robots", content: "noindex,nofollow" },
    ],
    links: [
      { rel: "preconnect", href: "https://pfzkgqaoufsyvhvwzqtk.supabase.co", crossOrigin: "anonymous" },
    ],
  }),
  component: EmbedPreCheckoutGgPage,
});

function EmbedPreCheckoutGgPage() {
  const { slug } = Route.useParams();
  const { tipo } = Route.useSearch();
  if (!isSlug(slug)) throw notFound();
  return <EmbedPreCheckoutView slug={slug} tipo={tipo} variant="gg" />;
}
